import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const notify = (message, message_type) => {
    toast(message, { type: message_type === "warning" ? "error" : message_type })
};

export default notify